import { Spinner } from '@/components/ui/Spinner';
import UnauthorizedPage from '@/pages/errors/UnauthorizedPage';
import ForbiddenPage from '@/pages/errors/ForbiddenPage';
import { Navigate } from 'react-router-dom';
import { type AdminConsoleSection, useAdminConsoleAccess } from '@/lib/auth/admin-console-access';

interface RequireAdminConsoleSectionProps {
  section: AdminConsoleSection;
  children: React.ReactNode;
}

export function RequireAdminConsoleSection({ section, children }: RequireAdminConsoleSectionProps) {
  const { isLoading, isAuthLoading, isAuthenticated, isUnauthorized, access } = useAdminConsoleAccess();

  if (isAuthLoading || isLoading) {
    return (
      <div className="flex h-full min-h-screen items-center justify-center bg-gray-50">
        <div className="flex flex-col items-center gap-4">
          <Spinner size="lg" />
          <p className="text-sm text-gray-500">Checking access...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated || isUnauthorized) {
    return <UnauthorizedPage />;
  }

  if (!access[section]) {
    if (!access.dashboard) {
      return <Navigate to="/" replace />;
    }

    return <ForbiddenPage />;
  }

  return <>{children}</>;
}
